module.exports = __webpack_public_path__ + "media/images/icon-download-white-b3e5c5ee.svg";